import { motion } from "framer-motion";

export const Statement = ({ text, inverted = false, id, label }) => (
  <section
    id={id}
    className={`relative min-h-[75vh] flex items-center justify-center px-6 sm:px-12 py-24 overflow-hidden ${inverted ? "bg-[#F4F4F0] text-[#0A0A0A]" : ""}`}
    data-testid={`statement-${text.slice(0, 18).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
  >
    {!inverted && (
      <motion.div
        aria-hidden="true"
        initial={{ scale: 0.7 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true, margin: "-120px" }}
        transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
        className="statement-glow absolute inset-0 m-auto w-[80vw] max-w-5xl h-[45vh] rounded-full pointer-events-none"
      />
    )}
    <div className="overflow-hidden max-w-6xl relative">
      {label && (
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.4 }}
          className={`font-meta text-[10px] sm:text-xs tracking-[0.4em] text-center mb-8 ${inverted ? "text-black/50" : "text-blue-300/60"}`}
        >
          {label}
        </motion.p>
      )}
      <motion.p
        initial={{ y: "60%", opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true, margin: "-120px" }}
        transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
        className="font-display font-extrabold uppercase tracking-tighter leading-[0.95] text-[clamp(2rem,7vw,6.5rem)] text-center text-aura-gradient"
      >
        {text}
      </motion.p>
    </div>
  </section>
);
